import { render } from "./UnNftCollectionMenu.vue?vue&type=template&id=5fb1d38c"
import script from "./UnNftCollectionMenu.vue?vue&type=script&lang=js"
export * from "./UnNftCollectionMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__